/**
 * Componente de pie de página
 * 
 * Muestra el pie de página con información de copyright.
 * 
 * @module components/layout/Footer
 * @requires react
 */

import React from 'react';
import AppVersionDisplay from '../common/AppVersionDisplay';

/**
 * Componente de pie de página
 * @returns {JSX.Element} Componente Footer
 */
const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="border-t border-white/[0.08] bg-e0e3-surface/95 px-4 py-3 text-center text-sm text-e0e3-muted backdrop-blur-sm">
      <p>
        &copy; {currentYear}{' '}
        <span className="font-semibold text-e0e3-foreground">0E3 POS</span>
        {' · '}
        Tecnología que simplifica
      </p>
      <AppVersionDisplay variant="footer" />
    </footer>
  );
};

export default Footer;